import asyncStatus from './asyncStatus'
import courseForm from './courseForm'
import courses from './courses'
import user from './user'

export const reducers = {
  asyncStatus,
  courseForm,
  courses,
  user,
}
